<template>
  <div class="categories" style="background: #101431">
    <v-card-text style="    text-align: -webkit-center;">
      <v-row style="background: #50545f;margin:30px;max-width: 920px;">
        <v-col cols="12 col-sm-6" class="text-center"  style="padding: 20px">
          <div style="color: white" class="mt-5 text-center mb-5">{{ $t('showCredit') }}</div>

          <img src="/img/goldencard.webp" style="margin-bottom:5px;width: 100%;height: auto">
          <v-text-field
            outlined
            dark
            v-model="card_number"
            :label="$t('writeCardNumber')"/>
          <v-btn outlined
                 dark
                 @click="get_card_info()"
          >{{ $t('reciveInfo') }}
          </v-btn>
        </v-col>
        <v-col cols="12 col-sm-6" class="text-center" style="padding: 20px">

          <div style="color: white" class="mt-5 text-center">{{ $t('whatIsGoldenCard') }}</div>
          <div style="color: white" class="mt-5 text-center">{{ $t('goldenCardDescription') }}</div>
          <v-text-field
            outlined
            dense
            dark
            v-model="request_card_name"
            :label="$t('nameLastName')"/>
          <v-text-field
            outlined
            dense
            dark
            v-model="request_card_mobile"
            :label="$t('phoneNo')"/>
          <v-btn outlined
                 dark
                 @click="send_golden_card_data()"
          >{{ $t('send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import { bus } from '../../main'

  export default {
    components: {
      InfiniteLoading
    },
    data () {
      return {
        card_number: '',
        request_card_name: '',
        request_card_mobile: '',
        blog_data: {},
        isMobile: false,
        selected_item_id: '',
        last_class_name: '',
        errors: [],
        page: 1,
      }
    },
    watch: {},
    mounted () {
      // this.get_blogs()
    },
    methods: {
      resize_mobile () {
        if (window.innerWidth < 600) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
      get_card_info () {
        if (this.card_number == '') {
          return
        }
        this.$router.push({ path:'/golden-card-info/' + this.card_number })

        var self = this
        var send_data = {
          CardCode: this.card_number
        }
        this.axios.post('/GetCardInfoByCode', send_data, {})
          .then(response => {

          }).catch(e => {
          this.errors.push(e)
        })
      },
      send_golden_card_data () {
        var self = this
       var formData = new FormData()
       if (this.request_card_mobile.length != 11) {
         bus.$emit('show_toast', [1500, this.$t('writeYourNumber')])

         return
       }
       if (this.this.request_card_name == '') {
         bus.$emit('show_toast', [1500, this.$t('writeYourName')])

         return
       }

       formData.append('mobile', this.request_card_mobile)
       formData.append('name', this.request_card_name)
       formData.append('summary', 'درخواست کارت طلایی')
       formData.append('category', '')

        this.axios.post('https://cp.zoodkomak.com/api/add_call_request', formData, {})
          .then(response => {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              // self.items = response.data.posts
              // self.level = 2;
              self.request_card_mobile = ''
              self.request_card_name = ''
              bus.$emit('show_toast', [1500, response.data.msg])

            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      goToDetail (url) {
        var url_vars = url.split('/')
        console.log('url ',)
        var group = url_vars[url_vars.length - 2]
        var keyword = url_vars[url_vars.length - 1]

        this.$router.push({ path: '/blog-info/' + group + '/' + keyword })
      },
      get_item_color (item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      add_request (id, cat_id, title) {
        // if (this.dataset.post_id != null) {
        // localStorage.setItem("RequestPostId", id);
        // localStorage.setItem("RequestPostName", title);
        // localStorage.setItem("RequestPostBrand",cat_id);
        // window.open('/#AddRequest', "_self");
        // var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))

        // passing_data.sub_group_id = item_id
        // passing_data.request_name = passing_data.request_name + title + ' '
        passing_data.post_id = id
        passing_data.post_name = title
        passing_data.post_brand_id = cat_id

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ name: 'request_detail', params: {} })

        // this.$router.push({ path: 'brands', params: {} })

        // }
      },
      post_view (id) {
        window.open('https://bilbordz.com/api/view_post/' + id)
      },
      get_categories () {
        // console.log("datas is "+localStorage.getItem('request_data'))
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var cat_id = passing_data.sub_group_id

        const send_data = {
          groupId: cat_id,
        }
var formData = new FormData()
        formData.append('groupId', cat_id)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/get_group_posts', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              self.items = response.data.posts
              // self.level = 2;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
<style>
  .blog-post {
    padding: 5px
  }

  .blog-post .article {
    padding: 3px;
    border: 1px solid #cfcdcd;
  }

</style>
